import { Button, Card, CardContent, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CardTitle from "@saleor/components/CardTitle";
import { FormChange } from "@saleor/hooks/useForm";
import { SmopUserTypeCode } from "@saleor/types/globalTypes";
import Moment from "moment";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    accountInformationRoot: {
      display: "grid",
      gridColumnGap: theme.spacing(4),
      gridTemplateColumns: "1fr"
    },
    card: {
      overflow: "visible"
    },
    cardTitle: {
      "& span": {
        fontWeight: "500"
      }
    },
    label: {
      marginBottom: theme.spacing(1)
    },
    prop: {
      marginBottom: theme.spacing(2)
    },
    root: {
      overflow: "visible"
    },

    sectionTitle: {
      fontWeight: 600 as 600,
      marginBottom: theme.spacing(),
      marginTop: theme.spacing(2)
    },

    textFieldGrid: {
      display: "grid",
      gridColumnGap: theme.spacing(2),
      gridTemplateColumns: "1fr 1fr"
    },
    value: {
      fontSize: 20
    }
  }),
  { name: "SellerInfo" }
);

interface AccountInfoProp {
  userType: any;
  mall: string;
  brand: string;
  tenant: string;
  company: string;
  dateJoined: string;
  disabled: boolean;
  canChangePassword: boolean;
  onChangePassword: () => void;
  onChange: FormChange;
}

export const AccountInfo: React.FC<AccountInfoProp> = ({
  userType,
  mall,
  brand,
  tenant,
  company,
  dateJoined,
  onChange,
  canChangePassword,
  onChangePassword,
  disabled
}) => {
  const classes = useStyles({});
  const intl = useIntl();
  return (
    <>
      <div>
        <Card>
          <CardTitle
            className={classes.cardTitle}
            title={intl.formatMessage({
              defaultMessage: "Account Information",
              description: "account information"
            })}
            toolbar={
              canChangePassword ? (
                <>
                  <Button
                    disabled={disabled}
                    onClick={onChangePassword}
                    color="primary"
                  >
                    <FormattedMessage
                      defaultMessage="Update Password"
                      description="button"
                    />
                  </Button>
                </>
              ) : null
            }
          />
          <CardContent>
            <div className={classes.accountInformationRoot}>
              {[
                SmopUserTypeCode.MALL_ADMIN,
                SmopUserTypeCode.OMI_OPS,
                SmopUserTypeCode.RIDER,
                SmopUserTypeCode.RUNNER
              ].includes(userType?.code) ? (
                <div className={classes.prop}>
                  <TextField
                    disabled={true}
                    label={intl.formatMessage({ defaultMessage: "Mall" })}
                    value={mall}
                    fullWidth
                  />
                </div>
              ) : null}
              {userType?.code === SmopUserTypeCode.SELLER_MASTER ? (
                <>
                  <div className={classes.prop}>
                    <TextField
                      disabled={true}
                      label={intl.formatMessage({
                        defaultMessage: "Trade Name"
                      })}
                      value={brand}
                      fullWidth
                    />
                  </div>
                  <div className={classes.prop}>
                    <TextField
                      disabled={true}
                      label={intl.formatMessage({
                        defaultMessage: "Company Name"
                      })}
                      value={company}
                      fullWidth
                    />
                  </div>
                </>
              ) : null}

              {userType?.code === SmopUserTypeCode.STORE_ADMIN ? (
                <div className={classes.prop}>
                  <TextField
                    disabled={true}
                    label={intl.formatMessage({ defaultMessage: "Store" })}
                    value={tenant}
                    fullWidth
                  />
                </div>
              ) : null}
              <div className={classes.prop}>
                <TextField
                  disabled={true}
                  label={intl.formatMessage({
                    defaultMessage: "Date Created"
                  })}
                  value={
                    !!dateJoined
                      ? Moment(dateJoined).format("MMMM D YYYY, h:mm:ss a")
                      : ""
                  }
                  onChange={onChange}
                  fullWidth
                />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
export default AccountInfo;
